import type { Observer } from '@apollo/client/core';

export function getObserver<T>(
    observerOrNext: Observer<T> | ((value: T) => void),
    onError?: (error: any) => void,
    onComplete?: () => void
): Observer<T> {
    if (typeof observerOrNext === 'function') {
        return {
            next: (v) => observerOrNext(v),
            error: (e) => onError && onError(e),
            complete: () => onComplete && onComplete(),
        };
    } else {
        return {
            next: (v) => observerOrNext.next && observerOrNext.next(v),
            error: (e) => observerOrNext.error && observerOrNext.error(e),
            complete: () =>
                observerOrNext.complete && observerOrNext.complete(),
        };
    }
}
